module.exports = __webpack_public_path__ + "img/arrow-down-left-square.8a4bcb14.svg";